import { Component, app, ojs } from "modular-openscriptjs";
import AddressPickerForm from "../Forms/AddressPickerForm";

const h = app("h");

ojs(AddressPickerForm);

export default class AddressPicker extends Component {
    holder = null;

    render() {
        return h.AddressPickerForm();
    }
}